import { render, staticRenderFns } from "./Mouth5.vue?vue&type=template&id=6b34c50e&"
import script from "./Mouth5.vue?vue&type=script&lang=js&"
export * from "./Mouth5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports